(function () {
  'use strict';

  // --- Dark mode toggle ---
  var root = document.documentElement;
  function setTheme(dark) {
    root.classList.toggle('dark', dark);
    try {
      localStorage.setItem('theme', dark ? 'dark' : 'light');
    } catch (e) {}
    document
      .querySelectorAll('#theme-toggle, #theme-toggle-mobile')
      .forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(dark));
      });
  }
  document
    .querySelectorAll('#theme-toggle, #theme-toggle-mobile')
    .forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(root.classList.contains('dark')));
      btn.addEventListener('click', function () {
        setTheme(!root.classList.contains('dark'));
      });
    });
  // Follow system changes only when the user hasn't chosen explicitly.
  if (window.matchMedia) {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', function (e) {
        try {
          if (!localStorage.getItem('theme')) root.classList.toggle('dark', e.matches);
        } catch (err) {}
      });
  }

  // --- Mobile menu toggle ---
  var toggle = document.getElementById('menu-toggle');
  var menu = document.getElementById('mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('hidden') === false;
      toggle.setAttribute('aria-expanded', String(open));
    });
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.add('hidden');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // --- Sticky header shadow on scroll ---
  var header = document.getElementById('site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) {
        header.classList.add('is-scrolled');
        header.firstElementChild &&
          header
            .querySelector('nav')
            .classList.add('shadow-glow', 'border-brand-100');
      } else {
        header.classList.remove('is-scrolled');
        header
          .querySelector('nav')
          .classList.remove('shadow-glow', 'border-brand-100');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- Scroll reveal animations ---
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // --- Current year in footer ---
  var year = document.getElementById('year');
  if (year) year.textContent = String(new Date().getFullYear());

  // --- Smooth-scroll for in-page anchors ---
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      if (id.length > 1) {
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // --- Contact form (AJAX submit with graceful fallback) ---
  var contactForm = document.querySelector('[data-contact-form]');
  if (contactForm) {
    var feedback = contactForm.querySelector('[data-contact-feedback]');
    var submitBtn = contactForm.querySelector('[data-contact-submit]');
    var submitLabel = contactForm.querySelector('[data-contact-label]');
    var originalLabel = submitLabel ? submitLabel.textContent : '';

    function setFeedback(kind, message) {
      if (!feedback) return;
      feedback.classList.remove(
        'hidden',
        'border-emerald-200',
        'bg-emerald-50',
        'text-emerald-800',
        'border-rose-200',
        'bg-rose-50',
        'text-rose-800',
        'dark:border-emerald-500/30',
        'dark:bg-emerald-500/10',
        'dark:text-emerald-200',
        'dark:border-rose-500/30',
        'dark:bg-rose-500/10',
        'dark:text-rose-200'
      );
      if (kind === 'success') {
        feedback.classList.add(
          'border-emerald-200',
          'bg-emerald-50',
          'text-emerald-800',
          'dark:border-emerald-500/30',
          'dark:bg-emerald-500/10',
          'dark:text-emerald-200'
        );
      } else {
        feedback.classList.add(
          'border-rose-200',
          'bg-rose-50',
          'text-rose-800',
          'dark:border-rose-500/30',
          'dark:bg-rose-500/10',
          'dark:text-rose-200'
        );
      }
      feedback.textContent = message;
    }

    contactForm.addEventListener('submit', function (e) {
      if (!contactForm.checkValidity()) {
        e.preventDefault();
        setFeedback('error', 'กรุณากรอกข้อมูลที่จำเป็นให้ครบถ้วน');
        contactForm.reportValidity();
        return;
      }

      // Only intercept when fetch + a real action URL are available.
      var action = contactForm.getAttribute('action') || '';
      if (!window.fetch || !/^https?:\/\//i.test(action)) return;

      e.preventDefault();

      // Collect fields into a plain object; skip honeypot & internal fields.
      var data = new FormData(contactForm);
      var payload = {};
      data.forEach(function (value, key) {
        if (key.charAt(0) === '_') return;
        if (typeof value === 'string') payload[key] = value.trim();
      });
      // Honeypot: if filled, silently pretend success.
      if ((data.get('_honey') || '').toString().length > 0) {
        setFeedback(
          'success',
          'ส่งข้อความเรียบร้อยแล้ว ทีมงานจะติดต่อกลับภายใน 1 วันทำการ'
        );
        contactForm.reset();
        return;
      }
      payload.consent = data.get('consent') ? true : false;

      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      if (submitLabel) submitLabel.textContent = 'กำลังส่ง...';
      if (feedback) feedback.classList.add('hidden');

      fetch(action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('bad-status');
          setFeedback(
            'success',
            'ส่งข้อความเรียบร้อยแล้ว ทีมงานจะติดต่อกลับภายใน 1 วันทำการ'
          );
          contactForm.reset();
        })
        .catch(function () {
          setFeedback(
            'error',
            'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่อีกครั้ง หรือส่งอีเมลถึง support@deltasoft.co.th'
          );
        })
        .then(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
          if (submitLabel) submitLabel.textContent = originalLabel;
        });
    });
  }
})();
